<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <!-- Gender Filter -->
      <div class="col-4 col-md-2 col-lg-2">
        <select 
          class="form-select form-select-sm" 
          v-model="genderFilter" 
          @change="handleGenderFilter"
        >
          <option value="">{{ $t('teachers.allGenders') }}</option>
          <option value="M">{{ $t('teachers.male') }}</option>
          <option value="F">{{ $t('teachers.female') }}</option>
        </select>
      </div>
      
      <!-- Reset Button (Desktop) -->
      <div class="col-md-1 d-none d-md-block">
        <button 
          class="btn btn-outline-secondary btn-sm w-100" 
          @click="resetFilters"
          :title="$t('common.reset')"

        >
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>
      
      <!-- Search Input -->
      <div class="col-8 col-md-5 col-lg-5 position-relative">
        <input
          type="text"
          class="form-control form-control-sm ps-5"
          :placeholder="$t('teachers.searchPlaceholder')"
          v-model="searchTerm"
          @input="handleSearch"
          style="padding-right: 12px;" 
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>
      
      <!-- Reset Button (Mobile) -->
      <div class="col-12 d-md-none">
        <button 
          class="btn btn-outline-secondary btn-sm w-100" 
          @click="resetFilters"
        >
          <i class="fas fa-filter-circle-xmark"></i> {{ $t('common.reset') }}
        </button>
      </div>
      
      <!-- Add New Button -->
      <div class="col-12 col-md-4 col-lg-4">
        <button class="btn btn-secondary btn-sm w-100" @click="$emit('add')" v-can="'teachers.create'">
          <i class="fas fa-plus"></i>
          {{ $t('teachers.addNew') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { debounce } from 'lodash';

const searchTerm = ref('');
const genderFilter = ref('');

const emit = defineEmits(['search', 'gender', 'add']);

const handleSearch = debounce(() => {
  emit('search', searchTerm.value);
}, 300);

const handleGenderFilter = () => {
  emit('gender', genderFilter.value);
};

const resetFilters = () => {
  searchTerm.value = '';
  genderFilter.value = '';
  emit('search', '');
  emit('gender', '');
};
</script>
